import "./DesktopHeader.css";
import Logo from "../../assets/Logo";
import { UserMenu } from "../UserMenu/UserMenu";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import SelectCarrera from "../SelectCarrera/SelectCarrera";
import { selectTurnstileVerified } from "../../reduxSlices/globalFlagsSlice";

const DesktopHeader = () => {
  const turnstileVerified = useSelector(selectTurnstileVerified);
  const location = useLocation();
  const isSeleccionCarrera = location.pathname === "/carrera";

  return (
    <div className="desktop-header">
        <div className="desktop-header-info-logo">
          <div className="header-logo-container">
          <Logo />
          </div>
          {turnstileVerified && !isSeleccionCarrera && <SelectCarrera/>}
        </div>
        <div className="desktop-header-info-data">
          <UserMenu />
        </div>
    </div>
  );
};

export default DesktopHeader;
